import { render, staticRenderFns } from "./BookMayorCardForm.vue?vue&type=template&id=6d3b61f3&"
import script from "./BookMayorCardForm.vue?vue&type=script&lang=js&"
export * from "./BookMayorCardForm.vue?vue&type=script&lang=js&"
import style0 from "./BookMayorCardForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports